<template>
  <v-layout row>
  </v-layout>
</template>

<script>
export default {
  name: 'DevicesMap',
  data () {
    return {
    };
  },
  created () {
  }
};
</script>


// WEBPACK FOOTER //
// DevicesMap.vue?7a4071bb